<template>
  <section class="section container pt-3">
    <modules-manager ref="modules_manager" />
  </section>
</template>

<script>
import { get_configuration } from "@/utils";
import ModulesManager from "./Manager";

export default {
  name: "ModuleIndex",
  components: { ModulesManager },
  data() {
    return {
      is_loading: false,
      module_settings: {},
    };
  },
  methods: {
    retrieve_settings() {
      let v = this;
      get_configuration(this)
        .then((conf) => {
          v.module_settings = conf;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    create() {},
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {
    this.retrieve_settings();
  },
  created() {},
};
</script>

<style scoped></style>
